import PropTypes from 'prop-types'
import Button from './Button'
import { ArrowLeft } from '../icons'
import cn from '../modules/cn'
import Skeleton from './Skeleton'

function BackNavigation({
  label, to, onClick, href, small,
}) {
  return (
    <Button
      small={small}
      neutral
      to={to}
      onClick={onClick}
      href={href}
      leadingAddon={<ArrowLeft />}
      className={cn(
        'sm:w-min',
        small ? 'inset-x-[-10px]' : 'inset-x-[-14px]',
        !to && !onClick && 'pointer-events-none',
      )}
    >
      {label || <Skeleton className="w-16" />}
    </Button>
  )
}

BackNavigation.propTypes = {
  label: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  })]),
  onClick: PropTypes.func,
  href: PropTypes.string,
  small: PropTypes.bool,
}

BackNavigation.defaultProps = {
  label: null,
  to: null,
  onClick: null,
  href: null,
  small: false,
}

export default BackNavigation
